import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function get_user_details(request) {
    // console.log("update_user_details -> request", request);
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/get/user${objectToQueryString(request)}`,
    });
}
export { get_user_details };
